import React, { useEffect, useState, useRef } from "react";

import { Link as Scroll } from "react-scroll";
import { useLocation } from "react-router-dom";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
    faArrowDown,
    faArrowRight,
    faArrowLeft,
} from "@fortawesome/free-solid-svg-icons";

//Hero Image
import video from "../assets/heroImages/pltfrmHero2.mp4";

//TrainingGym
import trainingGym from "../assets/Services/girlWorkingOut.png"

//Graphics
import instagram from "../assets/graphics/Instagram.png"
import tour from "../assets/graphics/tourIcon.png"
import email from "../assets/graphics/email-icon.png"

//CoworkingSpace Carousel
import image1 from "../assets/Services/CoworkingSpaceCarousel/coworking1.jpg"
import image2 from "../assets/Services/CoworkingSpaceCarousel/coworking2.jpg";
import image3 from "../assets/Services/CoworkingSpaceCarousel/coworking3.jpg";

//ContentCreation
import contentCreation1 from "../assets/Services/girlsMirror.png"
import contentCreation2 from "../assets/Services/ContentCreation/contentCreation2.jpg";
import contentCreation3 from "../assets/Services/ContentCreation/contentCreation3.jpg";

//Styling
import '../styling/ServicesPage.scss'

function ServicesPage() {

    const location = useLocation();
        const elementRef1 = useRef(null);
        const elementRef2 = useRef(null);
        const elementRef3 = useRef(null);
        const elementRef4 = useRef(null);

    const images = [image1, image2, image3];

    const [count, setCount] = useState(0);
    
        useEffect(
            function () {
                if (location.pathname === "/services/traininggym") {
                    elementRef1.current.scrollIntoView({
                        behavior: "smooth",
                    });
                } else if (location.pathname === "/services/coworkingspace") {
                    elementRef2.current.scrollIntoView({
                        behavior: "smooth",
                    });
                } else if (location.pathname === "/services/contentcreationfacilities") {
                    elementRef3.current.scrollIntoView({
                        behavior: "smooth",
                    });
                } else if (location.pathname === "/services/groupclasses") {
                    elementRef4.current.scrollIntoView({
                        behavior: "smooth",
                    });
                }
            },
            [location]
        );
    function previousImage() {
        let slider = document.getElementById("slider");
        if (count === 0){
            return
        }else{
            slider.scrollLeft = slider.scrollLeft - 400;
            setCount(count - 1);
            console.log(count);
        }
    }

    function nextImage() {
        let slider = document.getElementById("slider");
        if (count === 2){
            return
        }else{
            slider.scrollLeft = slider.scrollLeft + 400;
            setCount(count + 1)
        }
    }
    return (
        <div>
            <header className="mainHeader">
                <video
                    src={video}
                    autoPlay
                    muted
                    loop
                    playsInline
                    type="video/mp4"
                    id="myVideo"
                ></video>
                <div className="wrapper">
                    <div className="title">
                        <h1>
                            Toronto's Premier Private Training Gym & Coworking
                            Space
                        </h1>
                        <p>
                            Bringing you a premium space to sweat, work, relax,
                            & connect
                        </p>
                    </div>

                    <div className="arrowContainer">
                        <div className="arrowContainerText">
                            <p>Discover how</p>
                            <div className="logoName"></div>
                            <p>works</p>
                        </div>
                        <div className="arrowHoverContainer">
                            <Scroll
                                to="traininggym"
                                smooth={true}
                                className="arrowIcon"
                            >
                                <FontAwesomeIcon icon={faArrowDown} />
                                <span className="sr-only sr-only-focusable">
                                    Click to scroll down the page.
                                </span>
                            </Scroll>
                        </div>
                    </div>
                </div>
            </header>

            <section className="trainingGym" ref={elementRef1} name="traininggym">
                <div className="wrapper">
                    <div className="trainingGymContainer">
                        <div className="trainingText">
                            <h2>Training Gym</h2>
                            <div>
                                <p>
                                    Our training gym is designed with quality
                                    and privacy in mind. We have 6 training
                                    alcoves and no more than 2 alcoves in one
                                    section. This means our clients never feel
                                    crowded!
                                </p>
                                <p>
                                    Each private alcove has its own dedicated
                                    power rack and access to a functional
                                    trainer. Additionally you have access to a
                                    range of equipment including dumbbells,
                                    kettlebells, med balls, TRX, rowing machine,
                                    stationary bike, bands, and plyo boxes. If
                                    we don’t have something you need we are
                                    always open to having a conversation with
                                    you about acquiring it!
                                </p>
                            </div>
                            <p className="trainingTextBold">
                                <strong>
                                    Book a tour to check out our facility and
                                    find out if PLTFRM is your home.
                                </strong>
                            </p>
                            <button>
                                <a href="https://calendly.com/pltfrm-fit/30mintour">
                                    Book a tour
                                </a>
                            </button>
                        </div>
                        <img src={trainingGym} alt="" />
                    </div>
                </div>
            </section>

            <section className="coworkingSpace" ref={elementRef2}>
                <div className="wrapper">
                    <div className="coworkingSpaceContainer">
                        <div className="coworkingText">
                            <div>
                                <h2>COWORKING SPACE</h2>
                                <p>
                                    Our coworking & lounge spaces are designed
                                    for you as a fitness professional to take
                                    our business to the next level. Taking
                                    advantage of our free wifi to get your
                                    computer work down between sessions. Take a
                                    private call in our phone booth. Use our
                                    coworking space to collaborate with other
                                    professionals. Use our coffee corner to
                                    treat your clients before or after a
                                    session. All members have 24/7 access.
                                </p>
                            </div>
                            <button>
                                <a href="https://calendly.com/pltfrm-fit/30mintour">
                                    Book a tour
                                </a>
                            </button>
                        </div>
                        <div className="coworkingCarousel">
                            <button
                                className="carouselButton buttonPrevious"
                                onClick={previousImage}
                            >
                                <FontAwesomeIcon icon={faArrowLeft} />
                            </button>
                            <div className="carouselImage" id="slider">
                                {images.map((image, index) => (
                                    <img
                                        src={image}
                                        alt=""
                                        key={index}
                                        className={
                                            index === images.length - 1
                                                ? "slide lastSlide"
                                                : "slide"
                                        }
                                    />
                                ))}
                            </div>
                            <div className="carouselDots" id="sliderDots">
                                {images.map((dot, index) => (
                                    <div
                                        key={index}
                                        className={
                                            index === count
                                                ? "dot activeDot"
                                                : "dot"
                                        }
                                    ></div>
                                ))}
                            </div>
                            <button
                                className="carouselButton buttonNext"
                                onClick={nextImage}
                            >
                                <FontAwesomeIcon icon={faArrowRight} />
                            </button>
                        </div>
                    </div>
                </div>
            </section>

            <secion className="contentCreation" ref={elementRef3}>
                <div className="wrapper">
                    <div>
                        <div className="contentCreationText">
                            <h2>Content Creation Facilities</h2>
                            <p>
                                PLTFRM is open for branding and commercial
                                photoshoots. You can use our training gym or our
                                content room. We have limited lighting equipment
                                available. All members get free access to
                                equipment based on availability. For commercial
                                shoot rates please contact our team at{" "}
                                <a href="mailto: marketing@pltfrm.fit">
                                    marketing@pltfrm.fit
                                </a>
                            </p>
                        </div>
                        <div className="contentCreationImages">
                            <img src={contentCreation1} alt="" />
                            <img src={contentCreation2} alt="" />
                            <img src={contentCreation3} alt="" />
                        </div>
                    </div>
                </div>
            </secion>

            <section className="servicesGroupClasses" ref={elementRef4}>
                <div className="wrapper">
                    <h2>GROUP CLASSES</h2>
                    <p>
                        Our group classes are designed to be intimate
                        experiences where you can get lots of 1-1 interaction
                        and guidance. Capped at 6 people, you are guaranteed
                        proper focus from your instructor.
                    </p>
                    <div className="classList">
                        <div className="classOption">
                            <div className="info">
                                <h4>STRENGTH AND CONDITIONING</h4>
                                <p>
                                    This class combines weightlifting,
                                    functional movements, and cardio drills to
                                    build muscle, burn fat, and enhance overall
                                    athletic performance.
                                </p>
                            </div>
                            <p>SUNDAYS AT 9AM</p>
                        </div>
                        <div className="classOption">
                            <div className="info">
                                <h4>SCULPT AND STRENGTH</h4>
                                <p>
                                    This program alternates weekly between lower
                                    and upper body workouts, using targeted
                                    exercises designed to maximize muscle
                                    growth. Perfect for those looking to
                                    increase size, strength, and overall
                                    performance in a fun, supportive group
                                    setting.
                                </p>
                            </div>
                            <p>THURSDAYS AT 7PM</p>
                        </div>
                        <div className="classOption">
                            <div className="info">
                                <h4>KETTLEBELL BURN</h4>
                                <p>
                                    Kettlebell Burn is a dynamic full-body
                                    strength class designed to challenge and
                                    tone every muscle.
                                </p>
                            </div>
                            <p>SATURDAYS 11AM</p>
                        </div>
                    </div>
                    <button>Join now</button>
                </div>
            </section>

            <section className="contactUsSection">
                <div className="wrapper">
                    <h2>Contact Us</h2>
                    <p>
                        Ready to find out if PLTFRM is your home? Get in touch
                        with us and let’s chat about what we can do for you!
                    </p>
                    <div className="contactOptions">
                        <div>
                            <a href="https://www.instagram.com/pltfrm.fit/">
                                <img src={instagram} alt="Instagram icon" />
                                <span className="sr-only sr-only-focusable">
                                    Link to Pltfrm.fit instagram
                                </span>
                            </a>
                            <h4>DM Us</h4>
                            <p>
                                Send us a message <br />
                                on instagram @pltfrm.fit
                            </p>
                        </div>
                        <div className="tourIcon">
                            <a href="https://calendly.com/pltfrm-fit/30mintour">
                                <img src={tour} alt="Tour location icon" />
                                <span className="sr-only sr-only-focusable">
                                    Link to book a tour at our location.
                                </span>
                            </a>
                            <h4>Book a tour</h4>
                            <p>
                                Visit for a free 30 minute tour to check out our
                                space.
                            </p>
                        </div>
                        <div>
                            <a href="mailto: marketing@pltfrm.fit">
                                <img src={email} alt="Email icon" />
                                <span className="sr-only sr-only-focusable">
                                    Link to send marketing@pltfrm.fit an email
                                </span>
                            </a>
                            <h4>Email us</h4>
                            <p>Send us an email at marketing@pltfrm.fit</p>
                        </div>
                    </div>
                </div>
            </section>
        </div>
    );
}

export default ServicesPage;
